import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext';
import { TRendition, TThumbnailPreviewEE } from '../../../types/types';

export type TContentHubSeriesDetailsProps = WithSitecoreContextProps & {
  fields: TContentHubSeriesDetailsFields;
  rendering?: ComponentRendering;
  params?: TContentHubSeriesDetailsParams;
};

export enum InnerComponentTypes {
  Split = 'split',
  Card = 'card',
}

export type TSeriesDetailFeatureItemData = TThumbnailPreviewEE & {
  contextItemUrl?: string;
};

export type TContentHubSeriesDetailsFields = {
  apiData: TSeriesDetailsData;
  itemData?: TSeriesDetailFeatureItemData;
  isComponentUnreleased?: boolean;
};

export type TContentHubSeriesDetailsParams = {
  backgroundColorOverlaySplit?: string;
  backgroundColorOverlayCardColumn?: string;
};

export type TBreadcrumb = {
  titleUrl: string;
  title: string;
};
export type TButton = {
  label: string;
  url: string;
  target?: string;
};

export type TSummarySpec = {
  key: string;
  value: string;
  active?: string;
  position?: string;
  status?: string;
};

export type TComponentTab = {
  key: string;
  value: string;
};

export type TFeatureRenditions = {
  rendition_desktop_size1200?: TRendition;
  rendition_desktop_size1000?: TRendition;
  rendition_desktop_size500?: TRendition;
  rendition_mobile_size500?: TRendition;
};

export type TAsset = TFeatureRenditions & {
  role: 'main' | 'video' | 'extvideo';
  position: number;
  alt: string;
  bigthumbnail: string;
  thumbnail: string;
  full: string;
};

export type TSeo = {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogType: string;
  ogImage: string;
  ogUrl: string;
  ogDescription: string;
  ogSiteName: string;
  jsonLdSchema: string;
  canonicalUrl: string;
};

export type TImage = {
  image?: string;
  imageAlt?: string;
  mobileImage?: string;
  imageAltMobile?: string;
};

export type TSeriesDetailsData = {
  id: number;
  titleUrl?: string;
  title?: string;
  formattedTitle?: string;
  eyebrow?: string;
  innerComponents: TComponentDetails[];
  description?: string;
  msrp?: string;
  optionalLabel1?: string;
  optionalLabel2?: string;
  breadcrumb?: TBreadcrumb[];
  button1?: TButton;
  button2?: TButton;
  button3?: TButton;
  summarySpecs?: TSummarySpec[];
  components?: TComponentTab[];
  active?: boolean;
  showInNavigation?: boolean;
  assets?: TAsset[];
  seo?: TSeo;
};

export type TComponentDetails = {
  id: number;
  componentType?: InnerComponentTypes;
  title?: string;
  layoutType?: string;
  eyebrow?: string;
  description?: string;
  button1?: TButton;
  button2?: TButton;
  image?: string;
  imageAlt?: string;
  assets?: TAsset[];
  innerComponents: TComponentDetails[];
  button?: TButton;
};

export type TComponentDetailsProps = {
  className?: string;
  component: TComponentDetails;
  backgroundColor?: TContentHubSeriesDetailsParams;
};

export type TBannerProps = {
  mediaCarouselClassName?: string;
  component: TComponentDetails;
  mediaHeightClassName?: string;
  shouldShowOnlyFirstItem?: boolean;
  mobileRenditionKey?: keyof TFeatureRenditions;
  desktopRenditionKey?: keyof TFeatureRenditions;
};

export type TGalleryProps = {
  assets?: TAsset[];
  mediaHeightClassName?: string;
};

export type TModalComponentsListProps = {
  components: Array<TComponentDetails>;
  backgroundColor?: string;
};

export type TModalComponentsItemProps = {
  component: TComponentDetails;
  backgroundColor?: string;
};

export type TInnerCardProps = TModalComponentsItemProps & { cardsCount: number };

export type TFeatureHeaderProps = {
  title?: string;
  titleKeySeriesFeature?: string;
};
